var _rect, _path, _path2, _rect2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaticx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 584,
    height: 584,
    viewBox: "0 0 584 584",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 584,
    height: 584,
    rx: 292,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.336 165.659 419.34 506.663 507 419.004 165.995 78l-87.66 87.659Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.996 506.664 507 165.66 419.341 78 78.337 419.005l87.659 87.659Z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 108,
    width: 368,
    height: 368,
    rx: 184,
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M361.236 245.99c-4.92-2.81-11.246-2.81-16.87 0l-39.363 23.181-26.711 14.751-38.66 23.181c-4.921 2.81-11.247 2.81-16.87 0l-30.226-18.264c-4.92-2.81-8.435-8.429-8.435-14.751v-35.123c0-5.619 2.812-11.239 8.435-14.751l30.226-17.561c4.92-2.81 11.246-2.81 16.87 0l30.225 18.263c4.921 2.81 8.435 8.43 8.435 14.752v23.181l26.711-15.454v-23.883c0-5.62-2.812-11.24-8.435-14.752l-56.233-33.015c-4.921-2.81-11.247-2.81-16.87 0l-57.639 33.718c-5.624 2.809-8.435 8.429-8.435 14.049v66.03c0 5.619 2.811 11.239 8.435 14.751l56.936 33.015c4.92 2.81 11.246 2.81 16.87 0l38.66-22.478 26.711-15.454 38.66-22.478c4.921-2.81 11.247-2.81 16.87 0l30.226 17.561c4.92 2.81 8.435 8.429 8.435 14.751v35.123c0 5.619-2.812 11.239-8.435 14.751l-29.523 17.561c-4.92 2.81-11.246 2.81-16.87 0l-30.225-17.561c-4.921-2.81-8.435-8.429-8.435-14.751v-22.479l-26.711 15.454v23.181c0 5.62 2.812 11.239 8.435 14.751l56.936 33.015c4.921 2.81 11.247 2.81 16.87 0l56.936-33.015c4.921-2.809 8.435-8.429 8.435-14.751v-66.733c0-5.619-2.811-11.239-8.435-14.751l-56.936-33.015Z",
    fill: "#8247E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaticx);
export default __webpack_public_path__ + "static/media/maticx.93134e9b3b7bfd8a0c9cdca28bbb791a.svg";
export { ForwardRef as ReactComponent };